// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error--main[data-v-0d99f0ce]{margin-bottom:24px}.error--main .error__title[data-v-0d99f0ce]{font-size:2em}.error--main .error__icon[data-v-0d99f0ce]{display:inline-block}.error--main .error__message[data-v-0d99f0ce]{font-size:1.2em;padding-left:56px}#errorBtn[data-v-0d99f0ce]{width:14em;text-align:center;margin:2em auto auto;color:#000}", ""]);
// Exports
module.exports = exports;
